import { MantineThemeOverride } from '@mantine/core';

const theme: MantineThemeOverride = {
    colors: {
        primary: [
            '#99bad9',
            '#80a9cf',
            '#6698c5',
            '#4d87bc',
            '#3375b2',
            '#1a64a9',
            '#00539F', // main
            '#004b8f',
            '#00427f',
            '#003a6f',
        ],
        secondary: [
            '#f0a9a4',
            '#ed948e',
            '#e97f77',
            '#e56960',
            '#e15449',
            '#de3e33',
            '#da291c', // main
            '#c42519',
            '#ae2116',
            '#991d14',
        ],
        orange: [
            '#FFF7ED',
            '#FEF3E2', // light bg
            '#FED7AA',
            '#FDBA74',
            '#FB923C',
            '#F97316', // main
            '#EA580C',
            '#C2410C',
            '#9A3412',
            '#7C2D12',
        ],
        progressGreen: [
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
            '#10B981',
        ],
        progressBlue: [
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
            '#1458EC',
        ],
        progressOrange: [
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
            '#E59332',
        ],
        progressRed: [
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
            '#C92A2A',
        ],
        progressGray: [
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
            '#868E96',
        ],
    },

    components: {
        Button: {
            defaultProps: {
                color: 'primary',
                radius: 'xl',
                size: 'lg',
                fullWidth: true,
            },
        },
        Tabs: {
            defaultProps: {
                classNames: {
                    tabsList: 'border-none',
                    tabLabel: 'text-gray-400',
                    tab: 'active:text-primary',
                },
            },
        },
        TextInput: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        PasswordInput: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        Input: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        Select: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        NativeSelect: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        MultiSelect: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        DateInput: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        NumberInput: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        TagsInput: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        Textarea: {
            defaultProps: {
                radius: 'lg',
                size: 'md',
            },
        },
        Switch: {
            defaultProps: {
                size: 'md',
            },
        },
        Pill: {
            defaultProps: {
                radius: 'lg',
            },
        },
        PinInput: {
            defaultProps: {
                radius: 'lg',
                size: 'xl',
            },
        },
        Drawer: {
            defaultProps: {
                position: 'right',
            },
        },
    },
    primaryColor: 'primary',
};

export default theme;
